var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamelogo11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "yd9i88t0ka",
    d: "M0 0L20 0 20 20 0 20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ewd9usyfpc",
    d: "M0 0.302L20.001 0.302 20.001 1.302 0 1.302z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-408 -422) translate(408 422)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qc9taqvtub",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yd9i88t0ka"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4B34FB",
    d: "M18.725 0H1.278C.573 0 0 .571 0 1.276v17.45C0 19.426.571 20 1.28 20h17.446C19.43 20 20 19.427 20 18.725V1.276C20 .571 19.43 0 18.725 0m0 1c.152 0 .275.124.275.276v17.45c0 .15-.123.274-.275.274H1.278C1.124 19 1 18.876 1 18.725V1.276C1 1.124 1.124 1 1.28 1h17.446",
    mask: "url(#qc9taqvtub)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-408 -422) translate(408 422) translate(0 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "eakbanvehd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ewd9usyfpc"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4B34FB",
    d: "M0 0.802L20.002 0.802",
    mask: "url(#eakbanvehd)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4B34FB",
    strokeLinecap: "round",
    d: "M4.154 10.263L15.847 10.263M4.154 12.766L15.847 12.766",
    transform: "translate(-408 -422) translate(408 422)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamelogo11);
export default __webpack_public_path__ + "static/media/gamelogo11.7d108e660faae7269ead7e6222bd4fdf.svg";
export { ForwardRef as ReactComponent };